import { useState, useEffect } from "react"

export interface IUseCountdownTimerProps {
  onComplete: () => void
  initialCount: number
  interval: number
  options?: {
    enable?: boolean
  }
}

export type UseCountdownTimer = (props: IUseCountdownTimerProps) => {
  countdownTimer: number
}

export const useCountdownTimer: UseCountdownTimer = ({
  onComplete = () => {},
  initialCount = 5,
  interval = 1000, // milliseconds
  options = {},
}) => {
  const [countdownTimer, setCountdownTimer] = useState(initialCount)
  const { enable = true } = options

  useEffect(() => {
    if (!enable) return

    setCountdownTimer(initialCount)

    const timer = setInterval(() => {
      setCountdownTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval)
          onComplete()
        }
        return prev - 1
      })
    }, interval)

    return () => clearInterval(timer) // Cleanup on unmount or state change
  }, [enable, onComplete, initialCount, interval])

  return { countdownTimer }
}
